export default __webpack_public_path__ + "static/media/characterLife.38b6981f.jpeg";